import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appUIReducer from 'features/appUI/slice';
import authReducer from 'features/auth/slice';
import companyReducer from 'features/company/slice';
import internalDocumentReducer from 'features/internal-document/common/slice';
import userReducer from 'features/user/slice';
import workScheduleReducer from 'features/work-schedule/slice';
import workReducer from 'features/work/slice';
import { baseApi } from 'lib/rtkQuery/baseApi';

export const store = configureStore({
  reducer: {
    baseApi: baseApi.reducer,
    ui: appUIReducer,
    auth: authReducer,
    workSchedule: workScheduleReducer,
    work: workReducer,
    company: companyReducer,
    internalDocument: internalDocumentReducer,
    user: userReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // TODO: NamNH: temporary set to false to investigate issues with serialize mutation
      // serializableCheck: {
      //   ignoredPaths: ['scanner.onScan', 'modals'],
      //   ignoredActionPaths: ['payload.onScan', 'payload.element'],
      // },
      serializableCheck: false,
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
